import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SetDevelopmentPackageUserComponent } from './containers';

const routes: Routes = [
  {
    path: 'package-user',
    component: SetDevelopmentPackageUserComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DevelopmentRoutingModule {}
